<template>
	<div class="base-webshop-page-content">
		<h1 v-if="data?.seo_h1">{{ data.seo_h1 }}</h1>
		<div v-if="data?.content" v-html="data.content" v-interpolation />
	</div>
</template>

<script setup>
	const {data} = inject('baseCmsPageData', {data: null});
</script>
